<template>
  <div>
    <header class="hero-int">
      <div class="bb-container">
        <div class="hero-int__container">
          <div class="hero-int__left">
            <div class="hero-int__brand">
              {{ $t("babyRegistryHome.brand", lang) }}
            </div>
            <h1 class="hero-int__title">
              {{ $t("babyRegistryHome.heroTitle", lang) }}
            </h1>
            <div class="hero-int__actions">
              <a
                class="button button--lg button--accent button--primary"
                :href="$t('routes.signup', lang)"
              >
              {{ $t('babyRegistryHome.createBabyRegistry', lang) }}
              </a>
              <a
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
                class="link link--bold link--underline"
              >
                {{ $t("babyRegistryHome.viewSampleList", lang) }}
              </a>
            </div>
          </div>
          <div class="hero-int__cover">
            <picture>
              <source
                srcset="../../assets/img/covers/cover-fr-hero@2x.png"
                media="(min-width: 1399px) and (min-device-pixel-ratio: 2)"
              />
              <img src="../../assets/img/covers/cover-fr-hero.png" alt="" />
            </picture>
          </div>
        </div>
      </div>
    </header>
    <section class="rate-app">
      <div class="bb-container">
        <div class="rate-app__container">
          <div class="rate-app__title">
            {{ $t("babyRegistryHome.trustTitle", lang) }}
          </div>
          <div class="rate-app__card">
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-google-play.svg" alt="Google Play" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
            <hr />
            <div class="rate-app__item">
              <div class="rate-app__logo">
                <img src="../../assets/img/ico/ico-app-store.svg" alt="Apple App Store" />
              </div>
              <div class="rate-app__rate">4,8</div>
              <div class="rate-app__star">
                <img src="../../assets/img/ico/ico-star-fill.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="tiendas-list">
      <div class="tiendas-list__title">{{ $t("babyRegistryHome.anyProductAnyStore", lang) }}</div>
      <div class="tiendas-list__items">
        <VueSlickCarousel v-bind="shopSlider">
          <div class="tiendas-list__item" v-if="lang === 'es'">
            <img loading="lazy" src="../../assets/img/logos/logo-af-corte-ingles.svg" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-amazon.svg" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-ikea.svg" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-etsy.svg" />
          </div>
          <div class="tiendas-list__item" v-if="lang === 'es'">
            <img loading="lazy" src="../../assets/img/logos/logo-af-tutete.png" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-maisons.svg" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-kiabi.svg" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-ikea.svg" alt="IKEA" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-hm.svg" alt="H & M" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-maisons.svg" alt="Maisons du monde" />
          </div>
          <div class="tiendas-list__item">
            <img loading="lazy" src="../../assets/img/logos/logo-af-zara.svg" alt="Zara" />
          </div>
        </VueSlickCarousel>
      </div>
    </section>
    <section class="hbb-features">
      <div class="bb-container">
        <div class="hbb-features__title" v-html="$t('babyRegistryHome.reinventedTitle', lang)"></div>
        <div class="hbb-features__items">
          <div class="hbb-features__item">
            <div class="hbb-features__ico">
              <img loading="lazy" src="../../assets/img/ico/ico-color-list-heart.svg" />
            </div>
            <div class="hbb-features__footer">
              <div class="hbb-features__h">{{ $t("babyRegistryHome.beautifulPersonalTitle", lang) }}</div>
              <div class="hbb-features__sh">
                {{ $t("babyRegistryHome.beautifulPersonalDescription", lang) }}
              </div>
            </div>
          </div>
          <div class="hbb-features__item">
            <div class="hbb-features__ico">
              <img loading="lazy" src="../../assets/img/ico/ico-color-click-mobile.svg" />
            </div>
            <div class="hbb-features__footer">
              <div class="hbb-features__h">{{ $t("babyRegistryHome.easyForEveryoneTitle", lang) }}</div>
              <div class="hbb-features__sh">
                {{ $t("babyRegistryHome.easyForEveryoneDescription", lang) }}
              </div>
            </div>
          </div>
          <div class="hbb-features__item">
            <div class="hbb-features__ico">
              <img loading="lazy" :src="icoFree" />
            </div>
            <div class="hbb-features__footer">
              <div class="hbb-features__h">{{ $t("babyRegistryHome.freeTitle", lang) }}</div>
              <div class="hbb-features__sh">
                {{ $t("babyRegistryHome.freeDescription", lang) }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="app-avanzada">
      <div class="bb-container">
        <div class="app-avanzada__container">
          <aside class="app-avanzada__left">
            <div class="app-avanzada__title">{{ $t("babyRegistryHome.freeAppTitle", lang) }}</div>
            <div class="app-avanzada__description">
              {{ $t("babyRegistryHome.freeAppQuestion", lang) }}
            </div>
            <div class="app-avanzada__actions">
              <!-- <a href="#" class="link link--bold link--underline">
                  Découvrez notre application gratuite
                </a> -->
              {{ $t("babyRegistryHome.freeAppDescription", lang) }}
            </div>
            <div class="app-avanzada__stores" target="_blank">
              <a :href="$t('links.mobileAppUrlAndroid', lang)">
                <img
                  loading="lazy"
                  :src="googlePlayBadge"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
              <a :href="$t('links.mobileAppUrlIos', lang)" target="_blank">
                <img
                  loading="lazy"
                  :src="appStoreBadge"
                  alt=""
                  width="140"
                  height="40"
                />
              </a>
            </div>
          </aside>
          <picture class="app-avanzada__cover">
            <img
              :src="coverBabyRegistryApp"
              :alt="$t('home2.appTitle', lang)"
            />
          </picture>
        </div>
      </div>
    </section>
    <main class="home-beneficios">
      <div class="bb-container">
        <div class="home-beneficios__items">
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img src="../../assets/img/covers/cover-fr-heart-sale.png" alt="" />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                {{ $t("babyRegistryHome.anyProductAnyStore", lang) }}
              </div>
              <div class="home-beneficios__description">
                {{ $t("babyRegistryHome.totalFreedomDescription", lang) }}
              </div>
              <ul class="home-beneficios__list">
                <li>{{ $t("babyRegistryHome.uniqueSmallBrands", lang) }}</li>
                <li>{{ $t("babyRegistryHome.bestDealsBigStores", lang) }}</li>
              </ul>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                :src="coverReceiveMoney"
                alt="Lista para recibir dinero en tu hucha."
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                {{ $t("babyRegistryHome.receiveMoneyTitle", lang) }}
              </div>
              <div class="home-beneficios__description">
                {{ $t("babyRegistryHome.receiveMoneyDescription", lang) }}
              </div>
              <div class="home-beneficios__actions">
                <a
                  class="link link--bold link--underline"
                  :href="$t('routes.hucha-de-nacimiento', lang)"
                >
                  {{ $t("babyRegistryHome.learnMore", lang) }}
              </a>
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover">
              <img
                :src="coverPriceTracking"
                alt="Ofrece la posibilidad de compartir las compras más caras"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                {{ $t("babyRegistryHome.shopRightTimeTitle", lang) }}
              </div>
              <div class="home-beneficios__description">
                {{ $t("babyRegistryHome.shopRightTimeDescription", lang) }}
              </div>
              <div class="home-beneficios__footnote">
                {{ $t("babyRegistryHome.priceTrackingFootnote", lang) }}
              </div>
            </div>
          </section>
          <section class="home-beneficios__item">
            <div class="home-beneficios__cover home-beneficios__cover--rounded">
              <img
                src="../../assets/img/covers/promos_home.webp"
                :alt="$t('babyRegistryHome.neverMissDealTitle', lang)"
              />
            </div>
            <div class="home-beneficios__right">
              <div class="home-beneficios__title">
                {{ $t("babyRegistryHome.neverMissDealTitle", lang) }}
              </div>
              <div class="home-beneficios__description">
                {{ $t("babyRegistryHome.neverMissDealDescription", lang) }}
              </div>
              <div class="home-beneficios__actions">
                <a
                  class="link link--bold link--underline"
                  :href="$t('routes.deals', lang)"
                >
                  {{ $t("babyRegistryHome.learnMore", lang) }}
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </main>
    <div class="feedback-int">
      <div class="bb-container">
        <div class="feedback-int__title">{{ $t("babyRegistryHome.reviewsTitle", lang) }}</div>
        <div class="feedback-int__items">
          <VueSlickCarousel v-bind="reviewsSlider">
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-marta.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    {{ $t("babyRegistryHome.reviewMarta", lang) }}
                  </div>
                  <div class="feedback-user__name">Marta</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-estefania.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    {{ $t("babyRegistryHome.reviewEstefania", lang) }}
                  </div>
                  <div class="feedback-user__name">Estefanía</div>
                </div>
              </div>
            </div>
            <div class="feedback-int__item">
              <div class="feedback-user">
                <div class="feedback-user__cover">
                  <img src="../../assets/img/covers/testimonial-ichamar.jpg" alt="" />
                </div>
                <div class="feedback-user__content">
                  <div class="feedback-user__string">
                    {{ $t("babyRegistryHome.reviewPier", lang) }}
                  </div>
                  <div class="feedback-user__name">Pier</div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        </div>
      </div>
    </div>
    <section class="multi-share">
      <div class="bb-container">
        <div class="multi-share__container">
          <article class="multi-share__article">
            <div class="multi-share__title">{{ $t("babyRegistryHome.shareWishesTitle", lang) }}</div>
            <div class="multi-share__description">
              {{ $t("babyRegistryHome.shareWishesDescription", lang) }}
            </div>
          </article>
          <picture class="multi-share__cover">
            <img
              src="../../assets/img/covers/cover-multi-men-share.png"
              :alt="$t('babyRegistryHome.shareWishesTitle', lang)"
            />
          </picture>
        </div>
      </div>
    </section>
    <section class="acomp" style="background: #edecf9">
      <div class="bb-container">
        <div class="acomp__container">
          <div class="acomp__left">
            <div class="acomp__title">{{ $t("babyRegistryHome.pregnancySupportTitle", lang) }}</div>
            <div class="acomp__description">
              <p>
                {{ $t("babyRegistryHome.pregnancySupportDescription1", lang) }}
              </p>
              <p>
                {{ $t("babyRegistryHome.pregnancySupportDescription2", lang) }}
              </p>
            </div>
          </div>
          <div class="acomp__right">
            <img
              :src="coverPregnancySupport"
              :alt="$t('babyRegistryHome.pregnancySupportDescription1', lang)"
            />
          </div>
        </div>
      </div>
    </section>
    <section style="background: rgba(205, 239, 242, 0.4)">
      <div class="bb-container">
        <div style="padding-top: 60px; padding-bottom: 60px">
        <div class="acomp__title" style="font-size: 1.5rem;">{{ $t("babyRegistryHome.helloWishSectionTitle", lang) }}</div>
        <div class="acomp__description">
          <p>
            {{ $t("babyRegistryHome.helloWishSectionDescription1", lang) }}
          </p>
          <p>
            {{ $t("babyRegistryHome.helloWishSectionDescription2", lang) }}
          </p>
        </div>
        </div>
      </div>
    </section>
    <section class="cta-yellow-fw">
      <div class="bb-container">
        <div class="cta-yellow-fw__cta">
          <div class="cta-yellow-fw__left">
            <div class="cta-yellow-fw__title">
              {{ $t("babyRegistryHome.finalCtaTitle", lang) }}
            </div>
            <div class="cta-yellow-fw__actions">
              <a
                :label="$t('babyRegistryHome.createBabyRegistry', lang)"
                class="button button--lg button--accent button--primary"
                :href="$t('routes.signup', lang)"
              >
                {{ $t('babyRegistryHome.createBabyRegistry', lang) }}
              </a>
              <div
                class="link link--bold link--underline"
                @click="$router.push({ name: 'guest', params: { id: exampleListId } })"
              >
                {{ $t("babyRegistryHome.viewSampleList", lang) }}
              </div>
            </div>
          </div>
          <div class="cta-yellow-fw__cover">
            <img src="../../assets/img/covers/cover-peluche-ropa-bb-comoda.jpg" alt="" />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import { buildSeoMetaInfo } from "../../seo/buildSeoMetaInfo.js";
import { HTML_LANG_MAP } from "../../seo/langMaps.js";

const URL_ALTS = {
  "es": "https://www.hellobb.net/lista-de-nacimiento",
  "fr-FR": "https://www.hellobb.net/liste-de-naissance",
  "it-IT": "https://www.hellobb.net/lista-di-nascita",
  "pt-BR": "https://www.hellobb.net/lista-de-nascimento",
  "nl-NL": "https://www.hellobb.net/geboortelijst",
  "de-DE": "https://www.hellobb.net/geburtsliste",
  "en-GB": "https://www.hellobb.net/baby-registry",
  "x-default": "https://www.hellobb.net/lista-de-nacimiento",
}

export default {
  name: "HomeBabyRegistry",

  metaInfo() {
  const seo = buildSeoMetaInfo({
    vm: this,
    alts: URL_ALTS,
    appLang: this.lang,
    htmlLangMap: HTML_LANG_MAP,
    title: this.$t("babyRegistryHome.metaTitle", this.lang),
    description: this.$t("babyRegistryHome.metaDescription", this.lang),
  });

  return {
    ...seo,

    script: [
      {
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "HelloBB",
          operatingSystem: ["Android", "iOS"],
          applicationCategory: "LifestyleApplication",
          offers: {
            "@type": "Offer",
            price: "0",
            priceCurrency: "EUR",
          },
        },
      },
      {
        type: "application/ld+json",
        json: {
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "HelloBB",
          legalName: "HelloBB S.L.",
          url: "https://www.hellobb.net",
          logo: "https://www.hellobb.net/logo-hellobb-dark.svg",
          description: this.$t("babyRegistryHome.metaDescription", this.lang),
          foundingDate: "2022",
          address: {
            "@type": "PostalAddress",
            streetAddress: "C/ Pompeu Fabra 36",
            addressLocality: "Tortosa",
            addressRegion: "Tarragona",
            postalCode: "43500",
            addressCountry: {
              "@type": "Country",
              name: "Spain",
            },
          },
          contactPoint: {
            "@type": "ContactPoint",
            contactType: "customer support",
            email: "hola@hellobb.net",
          },
          sameAs: [
            "https://www.instagram.com/holahellobebe/",
            "https://www.facebook.com/holahelloBB",
            "https://www.pinterest.es/holahelloBB/",
            "https://www.crunchbase.com/organization/hellobb",
          ],
        },
      },
    ],

    meta: [
      ...seo.meta,
      {
        itemprop: "image",
        content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
      },
      {
        property: "og:url",
        content: URL_ALTS[this.lang] || URL_ALTS["es"],
      },
      {
        property: "og:type",
        content: "website",
      },
      {
        property: "og:title",
        content: this.$t("babyRegistryHome.metaTitle", this.lang),
      },
      {
        property: "og:description",
        content: this.$t("babyRegistryHome.metaDescription", this.lang),
      },
      {
        property: "og:image",
        content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
      },
      {
        name: "twitter:card",
        content: "summary_large_image",
      },
      {
        name: "twitter:title",
        content: this.$t("babyRegistryHome.metaTitle", this.lang),
      },
      {
        name: "twitter:description",
        content: this.$t("babyRegistryHome.metaDescription", this.lang),
      },
      {
        name: "twitter:image",
        content: "https://www.hellobb.net/images/cover-portada.08a0882.png",
      },
    ],
  };
},
  components: {
    VueSlickCarousel,
  },
  data() {
    return {
      shopSlider: {
        slidesToShow: 8,
        arrows: false,
        autoplay: true,
        dots: false,
        variableWidth: false,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "20px",
        edgeFriction: 0.35,
        speed: 500,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 4,
            },
          },
          {
            variableWidth: true,
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            variableWidth: true,
            breakpoint: 575,
            settings: {
              slidesToShow: 2,
              variableWidth: true,
            },
          },
        ],
      },
      reviewsSlider: {
        slidesToShow: 3,
        arrows: false,
        autoplay: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 767,
            settings: {
              centerMode: true,
              slidesToShow: 1,
            },
          },
        ],
      },
    };
  },
  computed: {
    exampleListId() {
      const exampleLists = {
        es: process.env.PREVIEW_LIST_ES_ID,
        fr: process.env.PREVIEW_LIST_ID,
        it: process.env.PREVIEW_LIST_IT_ID,
        de: process.env.PREVIEW_LIST_EN_1_ID,
        nl: process.env.PREVIEW_LIST_EN_1_ID,
        pt: process.env.PREVIEW_LIST_EN_1_ID,
        en: process.env.PREVIEW_LIST_EN_1_ID,
      };
      return exampleLists[this.lang.substring(0, 2)] || exampleLists.es;
    },
    lang()  {
      return this.$route.meta?.lang || this.$i18n.locale;
    },
    googlePlayBadge() { 
      const badges = { 
        es: require("../../assets/img/logos/logo-app-google.svg"), 
        en: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
        fr: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
        it: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
        de: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
        nl: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
        pt: require("../../assets/img/logos/logo-app-google.en-GB.svg"), 
      }; 
      return badges[this.lang.substring(0, 2)] || badges.es;
    },
    appStoreBadge() { 
      const badges = { 
        es: require("../../assets/img/logos/logo-app-appstore.svg"), 
        en: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
        fr: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
        it: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
        de: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
        nl: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
        pt: require("../../assets/img/logos/logo-app-appstore.en-GB.svg"), 
      }; 
      return badges[this.lang.substring(0, 2)] || badges.es;
    },
    coverBabyRegistryApp() { 
      const covers = { 
        es: require("../../assets/img/covers/mockup_lista_ES.png"),
        en: require("../../assets/img/covers/mockup_lista_general_EN.png"), 
        fr: require("../../assets/img/covers/mockup-llista.png"), 
        it: require("../../assets/img/covers/mockup-llista-it.png"), 
        de: require("../../assets/img/covers/mockup_lista_general_EN.png"), 
        nl: require("../../assets/img/covers/mockup_lista_general_EN.png"), 
        pt: require("../../assets/img/covers/mockup_lista_general_EN.png"), 
      }; 
      return covers[this.lang.substring(0, 2)] || covers.es;
    },
    coverReceiveMoney() { 
      const covers = { 
        es: require("../../assets/img/covers/cover-recibiendo-dinero-es.png"),
        en: require("../../assets/img/covers/cover-multi-recibiendo-dinero-002-en.png"), 
        fr: require("../../assets/img/covers/cover-recibiendo-dinero.png"), 
        it: require("../../assets/img/covers/cover-it-recibiendo-dinero.jpg"), 
        de: require("../../assets/img/covers/cover-multi-recibiendo-dinero-002-en.png"), 
        nl: require("../../assets/img/covers/cover-multi-recibiendo-dinero-002-en.png"), 
        pt: require("../../assets/img/covers/cover-recibiendo-dinero-br.webp"), 
      }; 
      return covers[this.lang.substring(0, 2)] || covers.es;
    },
    coverPriceTracking() {
      const covers = { 
        es: require("../../assets/img/covers/monitorizacion-precios-baby-ES.png"),
        en: require("../../assets/img/covers/monitorizacion-precios-baby-EN.png"), 
        fr: require("../../assets/img/covers/monitorizacion-precios-baby-FR.png"), 
        it: require("../../assets/img/covers/monitorizacion-precios-baby-IT.png"), 
        de: require("../../assets/img/covers/monitorizacion-precios-baby-EN.png"), 
        nl: require("../../assets/img/covers/monitorizacion-precios-baby-EN.png"), 
        pt: require("../../assets/img/covers/monitorizacion-precios-baby-BR.webp"), 
      }; 
      return covers[this.lang.substring(0, 2)] || covers.es;
    },
    coverPregnancySupport() {
      const covers = { 
        es: require("../../assets/img/covers/cover-acompanamos-embarazo.webp"),
        en: require("../../assets/img/covers/cover-acompanamos-embarazo-en.webp"), 
        fr: require("../../assets/img/covers/cover-acompanamos-embarazo-fr.webp"), 
        it: require("../../assets/img/covers/cover-acompanamos-embarazo-it.webp"), 
        de: require("../../assets/img/covers/cover-acompanamos-embarazo-en.webp"), 
        nl: require("../../assets/img/covers/cover-acompanamos-embarazo-en.webp"), 
        pt: require("../../assets/img/covers/cover-acompanamos-embarazo-en.webp"), 
      }; 
      return covers[this.lang.substring(0, 2)] || covers.es;
    },
    icoFree() {
      const icons = { 
        es: require("../../assets/img/ico/ico-color-gratis.svg"), 
        en: require("../../assets/img/ico/ico-color-gratis-it.svg"), 
        fr: require("../../assets/img/ico/ico-color-gratuit.svg"), 
        it: require("../../assets/img/ico/ico-color-gratis-it.svg"), 
        de: require("../../assets/img/ico/ico-color-gratis-it.svg"), 
        nl: require("../../assets/img/ico/ico-color-gratis-it.svg"), 
        pt: require("../../assets/img/ico/ico-color-gratis-it.svg"), 
      }; 
      return icons[this.lang.substring(0, 2)] || icons.es;
    },
  },
};
</script>

<style lang="scss" scoped></style>
